import { useQuery, type UseQueryResult } from '@tanstack/react-query'

import { type TaxCategoryEntity } from '@/libs/api'

import { getTaxCategoriesSelectQueryOptions } from '../query-options'

type Options = {
  isActive?: boolean | undefined
  enabled?: boolean
  /**
   * true にすると `isActive` フィルタを外し、無効化済 (`isActive=false`) も含む全件を取得する。
   * 過去データの表示で論理削除済 TaxCategory の名称解決が必要な箇所で使う。
   */
  includeInactive?: boolean
}

/**
 * Select 用の税区分一覧 useQuery。
 * 既定で `isActive=true` のみを取得する。`includeInactive: true` で無効化済も含めて全件取得。
 */
export const useTaxCategoriesSelectQuery = (
  tenantKey: string,
  options?: Options
): UseQueryResult<TaxCategoryEntity[]> => {
  const isActive = options?.includeInactive
    ? undefined
    : (options?.isActive ?? true)
  const enabled = options?.enabled ?? true
  return useQuery<TaxCategoryEntity[]>({
    ...getTaxCategoriesSelectQueryOptions({ tenantKey, isActive }),
    enabled,
    retry: false
  })
}
